//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  Checkbox,
  CheckboxGroup,
} from 'vant'
import './CSearchCard.css'
import { isFunction } from '@/utils/validator'

export default {
  name: 'CSearchCard',

  components: {
    Checkbox,
    CheckboxGroup,
  },

  props: {
    item: {
      type: Object,
      default: () => ({}),
    },

    searchCardFormat: {
      type: [
        Array,
        Function,
      ],
      default: () => {
        return [
          {
            label: '中学名称',
            value: 'name',
          },
          {
            label: '地区',
            value: 'wid',
          },
        ]
      },
    },

    value: {
      type: [
        Array,
        String,
        Number,
      ],
      default: () => ([]),
    },

    valueName: {
      type: String,
      default: 'key',
    },

    multi: {// 是否支持多选,currentPage
      type: Boolean,
      default: false,
    },
  },

  computed: {
    checkActiveClass () {
      return this.value.includes(this.item[this.valueName]) ? 'active' : ''
    },

    innerSearchCardFormat () {
      if (isFunction(this.searchCardFormat)) {
        return this.searchCardFormat(this.item)
      } else {
        return this.searchCardFormat
      }
    },

    radioActiveClass () {
      return this.item[this.valueName] === this.value ? 'active radio-active' : ''
    },

    checkedValue: {
      set (value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      },
    },
  },
}
